<template>
  <BaseTableView :head="tableHead" :class="$vuetify.breakpoint.xlOnly ? 'table' : ''">
    <OfferAgreementTableItem v-for="item in items" :key="item.id" :item="item" :type="type" />
  </BaseTableView>
</template>

<script>
import OfferAgreementTableItem from 'components/setting/offerAgreement/OfferAgreementTableItem'
export default {
  name: 'WorkDocsDocumentTypeTable',
  props: ['items', 'type'],
  components: { OfferAgreementTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text:
            this.type == 'new'
              ? this.localStorage.translations.pages['setting-offer_agreement'].tables.name_new
              : this.type == 'history'
              ? this.localStorage.translations.pages['setting-offer_agreement'].tables.name
              : this.type == 'publish'
              ? this.localStorage.translations.pages['setting-offer_agreement'].tables.name_publish
              : '',
        },
        {
          text:
            this.type !== 'new'
              ? this.localStorage.translations.pages['setting-offer_agreement'].tables.date
              : '',
        },
        {
          text: this.localStorage.translations.pages['setting-offer_agreement'].tables.language,
        },
      ]
    },
  },
  methods: {},
  watch: {},
}
</script>

<style lang="scss" scoped>
.table:deep() {
  tr {
    th,
    td {
      &:nth-of-type(1) {
        width: 100%;
        max-width: 40%;
      }
      &:nth-of-type(2) {
        width: 100%;
        max-width: 30%;
      }
      &:nth-of-type(3) {
        width: 100%;
        max-width: 30%;
      }
    }
    td {
      cursor: pointer;
    }
  }
}
</style>
